import reframe from 'nike-re-framejs';
import { defaultMiddlewares } from '@/common/util';
import Immutable from 'immutable';
import { deepMergeNested } from 'nike-ui/src/common/immutable/merge';
import { fetchBannersByBetNumbers } from '@/nikeone/services';

function parseBetBanners(betIds, betBanners) {
    const map = betIds.reduce((acc, betId) => {
        acc[betId] = null;
        return acc;
    }, {});
    return betBanners.reduce((acc, banner) => {
        acc[banner.betId] = banner;
        return acc;
    }, map);
}

reframe.registerHandler('betbanners/fetch', defaultMiddlewares, (db, [betIds]) => {
    fetchBannersByBetNumbers(betIds)
        .then(data => dispatchBetBannersFetched(betIds, data))
        .catch(() => dispatchBetBannersFetched(betIds, []));
    return db;
});

function dispatchBetBannersFetched(betIds, data) {
    reframe.dispatch(['betbanners/fetched', betIds, data]);
    return data;
}

reframe.registerHandler('betbanners/fetched', defaultMiddlewares, (db, [betIds, betbanners]) => {
    const banners = Immutable.fromJS(parseBetBanners(betIds, betbanners));
    return db.update('betbanners', existing => deepMergeNested(existing, banners));
});
